<template>
    <div>
        <view-account-link v-if="!edit" :value="linkedAccount" v-bind="$attrs" edit @edit="edit = true" />
        <edit-account-link
            v-else
            :value="linkedAccount"
            v-bind="$attrs"
            @save="save"
            @completed="completed"
            @cancel="cancel"
        />
    </div>
</template>

<script>
import ViewAccountLink from './view_account_link'
import EditAccountLink from './edit_account_link'
import gql from 'graphql-tag'

export default {
    name: 'AccountLinkedAccountRoot',
    components: {
        ViewAccountLink,
        EditAccountLink
    },
    inheritAttrs: false,
    apollo: {
        accountLinking: {
            query: gql`
                query accountLinking {
                    accountLinking {
                        oldEmail
                        verified
                        createdAt
                        verifiedAt
                    }
                }
            `
        }
    },
    data() {
        return {
            edit: false
        }
    },
    computed: {
        linkedAccount() {
            return this.accountLinking
                ? {
                      email: this.accountLinking.oldEmail,
                      completed: this.accountLinking.verified,
                      createdAt: this.accountLinking.createdAt,
                      verifiedAt: this.accountLinking.verifiedAt
                  }
                : []
        }
    },
    methods: {
        save() {
            this.$apollo.queries.accountLinking.refetch() // always refetch to update state after changes are potentially made
            this.$auth.loadUserProfile() // always reload user profile when changes are potentially made
        },
        completed() {
            this.save()
            this.edit = false
        },
        cancel() {
            this.edit = false
        }
    }
}
</script>
